<template>
    <div class="summary-container" ref="container">
        <template v-if="isLoaded">
            <div class="summary-header">
                <h4 class="text-center">{{ data.forecast.forecastID }}</h4>
                <p class="text-center">Published: {{ data.forecast.pubDate }}</p>
            
                <div class="dropdown text-center">                    
                    <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">{{ monthButtonLabel }}</button>                    
                    <div class="dropdown-menu text-left">
                        <a v-for="monthIndex in monthIndexes" :key="monthIndex.index" href="#" class="dropdown-item" :class="{active: isSelectedMonth(monthIndex.index)}" :data-monthIndex="monthIndex.index" :data-index="monthIndex.index" :data-label="monthIndex.label" @click="monthIndex_Clicked">{{ monthIndex.label }}</a>
                    </div>
                </div>

                <hr/>
            </div>                        

            <div class="summary-view-container">
                <summary-view v-for="item in data.items" :key="item.id" v-bind:item="item" v-bind:month-index="monthIndex" v-bind:forecast-var-inventory="forecastVarInventory"></summary-view>
            </div>        
        </template>   
        <p v-else class="text-center">
            Loading, please wait...
        </p>

        <div class="resizer" @mousedown="resizeMouseDown" @mousemove="resizeMouseMove" @mouseup="resizeMouseUp"></div>
        <div class="resize-surface" ref="resizeSurface" @mousemove="surfaceMouseMove" @mouseup="surfaceMouseUp"></div>
        <div class="close-button">
            <a href="#" @click="close">&times;</a>
        </div>        
    </div>
</template>

<script>

import SummaryView from '@/components/SummaryView.vue'
import $ from '@/lib/JQuery.js'
import logger from '@/lib/logger.js'
import { SampleReportData } from '@/lib/SampleData.js'
import { ServiceController } from '@/lib/ServiceController.js'
import events from '@/lib/events.js'
import config from '@/lib/config.js'
import { ForecastID } from '@/lib/Forecast.js'
import MonthIterator from '@/lib/MonthIterator.js'
import SummaryData from '@/lib/SummaryData.js'

const BLANK_DATA = { forecast: { forecastID: '', pubDate: '' }, numMonths: 0, items: [] }
const MONTH_LABELS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

export default {
    name: 'SummaryContainer',
    components: {
        SummaryView
    },
    data() {
        return {
            isResizing: false,
            data: BLANK_DATA,
            monthIndex: 0,
            monthIndexes: [],
            forecastVarInventory: null
        }
    },    
    computed: {
        monthButtonLabel() {
            if (this.monthIndexes.length == 0)
                return 'Month'
            let item = this.monthIndexes[this.monthIndex]
            return 'Month: ' + item.label
        },
        isLoaded() {
            return this.data != null && this.data.numMonths > 0
        }
    },
    methods: {   
        openSummary(forecastVarInventory) {
            logger.log('SummaryContainer::openReport()', { forecastVarInventory: forecastVarInventory })
            
            this.$refs.container.style.display = 'flex'
            this.data = BLANK_DATA
            this.monthIndexes = []
            this.monthIndex = 0
            this.forecastVarInventory = forecastVarInventory

            if (config.useSampleSummaryData) {
                setTimeout(() => { 
                    let summaryData = new SummaryData(SampleReportData)
                    this.updateData(summaryData)
                }, 1000)
            }
            else {
                ServiceController.defaultReportData(
                    (data) => {
                        let summaryData = new SummaryData(data)
                        this.updateData(summaryData)
                    }, 
                    (error) => {
                        events.$emit(events.EVT_ERROR, 'Error getting summary data from the server: ' + error)
                    })
            }
        },
        isSelectedMonth(index) {
            return index == this.monthIndex
        },
        monthIndex_Clicked(e) {
            let monthIndex = e.target.dataset.monthindex
            let index = e.target.dataset.index
            let label = e.target.dataset.label

            this.monthIndex = index
        },
        close() {
            this.$refs.container.style.display = 'none'
        },     
        updateData(data) {
            logger.log('SummaryContainer::updateData()', data)

            this.data = data

            if (this.data.forecast != undefined && this.data.forecast.forecastID != undefined && this.data.numMonths != undefined) {
                let forecastID = new ForecastID(this.data.forecast.forecastID)
                let firstMonth = forecastID.getFirstForecastMonth()
                let monthIt = new MonthIterator(firstMonth, forecastID.getYear())
                let monthIndexes = []
                for(let i=0; i < this.data.numMonths; i++) {
                    monthIndexes.push({ index: i, monthIndex: monthIt.month, label: MONTH_LABELS[monthIt.month-1] })
                    monthIt.nextMonth()
                }
                this.monthIndexes = monthIndexes
            }
        },
        resizeMouseDown(event) {
            logger.log('resizeMouseDown', event)                
            this.isResizing = true      
            $(this.$refs.resizeSurface).fadeIn()
        },
        resizeMouseMove(event) {
            logger.log('resizeMouseMove', event)
        },
        resizeMouseUp(event) {
            logger.log('resizeMouseUp', event)        
            this.endResize()
        },
        surfaceMouseMove(event) {
            logger.log('surfaceMouseMove', event)

            if (!this.isResizing)
                return

            let surfaceWidth = this.$refs.resizeSurface.offsetWidth
            let newWidth = Math.min(surfaceWidth, Math.max(300, event.clientX))
            this.$refs.container.style.width = newWidth + 'px'
        },
        surfaceMouseUp(event) {
            logger.log('surfaceMouseUp', event)
            this.endResize()
        },
        endResize() {
            this.isResizing = false
            $(this.$refs.resizeSurface).fadeOut()
        }
    }
}
</script>

<style>
.summary-container {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;  
  background-color: white;
  border: 1px solid black;
  z-index: 1101;
  display: none;
  padding: 1em;
  display: none;
  flex-direction: column;
}

.summary-container .resizer {
  position: absolute;
  right: 5px;
  top: 50%;
  width: 10px;
  height: 40px;
  margin-top: -20px;
  background-color: #333355;
  border-radius: 4px;
  cursor: ew-resize;
  z-index: 1102;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;   
}

.resize-surface {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 1102;
  display: none;
}

@media screen and (min-width: 601px) {
  .summary-container {
    width: 600px;
    max-width: 100%;
  }  
}

@media screen and (max-width: 600px) {
  .summary-container{
    width: initial !important;
    right: 0;    
  }

  .summary-container .resizer {
    display: none;
  }
}

.close-button {
    position: absolute;
    right: 30px;
    top: 10px;
}  

.close-button a {
    font-weight: bold;
    color: black;
    text-decoration: none;
    font-size: 18pt;
    padding: 5px;
}

.close-button a:hover {
    text-decoration: none;
}

.summary-view-container {
    flex-grow: 1;
    overflow-y: auto;
}
</style>